// extracted by mini-css-extract-plugin
export var brand = "_6u-9";
export var compact = "_6u-6";
export var extraSmall = "_6u-7";
export var icon = "_6u-0";
export var large = "_6u-4";
export var light = "_6u-1";
export var medium = "_6u-5";
export var outline = "_6u-b";
export var primaryDark = "_6u-a";
export var primaryLight = "_6u-8";
export var primaryModern = "_6u-c";
export var success = "_6u-2";
export var successSolid = "_6u-3";